module.exports = __webpack_public_path__ + "static/media/414.3bd45e06.webp";